module.exports = new __parcel__URL__("pase-pro.da0f177e.png").toString();